import React from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { LayoutDashboard, Users, Shield, Map, AlertTriangle } from 'lucide-react';
import { useUserStore } from '@/store/userStore';
import { useNMNotifications } from '@/hooks/useNMNotifications';

const ITEMS = [
  { to: '/', label: 'Dashboard', icon: LayoutDashboard, exact: true },
  { to: '/liderazgo', label: 'Liderazgo', icon: Users },
  { to: '/ops', label: 'OPS', icon: Shield },
  { to: '/near-misses', label: 'NM', icon: AlertTriangle, nm: true },
  { to: '/mapa', label: 'Mapa', icon: Map },
];

export default function BottomNav() {
  const { token } = useUserStore();
  const navigate = useNavigate();
  const { unread, markAsRead } = useNMNotifications(token);

  return (
    <nav
      className="lg:hidden fixed bottom-0 left-0 right-0 z-30 flex border-t"
      style={{
        background: 'rgba(11,26,62,0.96)',
        backdropFilter: 'blur(16px)',
        borderColor: 'rgba(74,158,255,0.12)',
        paddingBottom: 'env(safe-area-inset-bottom, 0px)',
      }}
    >
      {ITEMS.map((item) => (
        <NavLink
          key={item.to}
          to={item.to}
          end={item.exact}
          onClick={item.nm && unread > 0 ? markAsRead : undefined}
          className={({ isActive }) =>
            `flex-1 flex flex-col items-center gap-0.5 py-2 text-[10px] font-medium transition-colors ${
              isActive ? 'text-[var(--vz-green)]' : 'text-[var(--vz-text-muted)] hover:text-white'
            }`
          }
        >
          {({ isActive }) => (
            <>
              <div className="relative">
                <item.icon size={18} className={isActive ? 'text-[var(--vz-green)]' : ''} />
                {item.nm && unread > 0 && (
                  <span
                    className="absolute -top-1.5 -right-2 min-w-[14px] h-3.5 rounded-full flex items-center justify-center text-[8px] font-bold px-0.5"
                    style={{ background: '#FF5252', color: '#fff' }}
                    data-testid="nm-badge-bottom-nav"
                  >
                    {unread > 9 ? '9+' : unread}
                  </span>
                )}
              </div>
              <span>{item.label}</span>
            </>
          )}
        </NavLink>
      ))}
    </nav>
  );
}
